import { render, staticRenderFns } from "./FinishConfiguration.vue?vue&type=template&id=533135ca&scoped=true&"
import script from "./FinishConfiguration.vue?vue&type=script&lang=js&"
export * from "./FinishConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./FinishConfiguration.vue?vue&type=style&index=0&id=533135ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533135ca",
  null
  
)

export default component.exports